{
	"content": {
		"title": "Wählen Sie die Materialien aus, für die Erklärungen erforderlich sind",
		"materialListLabel": "Material",
		"materialQuantityLabel": "Materialmenge ({{unit}})",
		"availableQuantityLabel": "Verfügbare Menge ({{unit}})",
		"carbonSavingsLabel": "CO₂-Reduktionen ({{unit}} CO\u2082 eq.)"
	},
	"summary": {
		"title": "Zusammenfassung",
		"declarationTypeTitle": "Erklärungstyp",
		"customerProjectTitle": "Kundenprojekt",
		"internalProjectOrProductTitle": "Internes Projekt / Produkt",
		"projectReferenceTitle": "Projektreferenz",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Menge ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Zuordenbare CO₂-Reduktionen ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Nicht zuordenbare CO₂-Reduktion ({{unit}})"
	},
	"errorMessages": {
		"materialRequired": "Material ist erforderlich",
		"materialDescriptionRequired": "Materialbeschreibung ist erforderlich",
		"customerIdRequired": "Kundennummer ist erforderlich",
		"quantityRequired": "Menge ist erforderlich",
		"quantityPositive": "Bitte geben Sie eine positive Menge ein.",
		"notEnoughQuantity": "Bitte wählen Sie eine höhere Menge.",
		"quantityLargerThanAvailable": "Bitte verringern Sie die Menge auf die insgesamt verfügbare Menge",
		"totalQuantityRequired": "Verfügbare Menge ist erforderlich",
		"savingsRequired": "CO₂-Reduktionen sind erforderlich",
		"unitRequired": "Einheit ist erforderlich",
		"fetchNotTransferedMaterialsError": "Nicht übertragene Materialien konnten nicht abgerufen werden",
		"DeclarationErrors": {
			"NoAvailableInvoices": "Es sind keine verfügbaren Rechnungen zum Übertragen vorhanden",
			"NotEnoughMaterial": "Es sind nicht genügend Rechnungen vorhanden, um fortzufahren"
		}
	},
	"submitTitle": "Zum Projekt hinzufügen",
	"backTitle": "Zurück"
}
